import { MutationTree } from "vuex"
import { SessionState, SESSION_STORE as s } from "./type";
export const mutations: MutationTree<SessionState> = {
    [s.SET_SESSION](state, session) {
        state.session = session;
    },
    [s.SET_DATERANGE](state, newval) {
        state.dateRange = newval;
    },
    [s.SET_LOCALDB_COMPLETE](state, newval) {

        state.isLocalDBComplete = newval;
    },
    [s.SET_LOCALDB_STATUS](state, newval) {

        state.localDBStatus = newval;
    },
    [s.SET_MEMDB_STATUS](state, newval) {

        state.memDBStatus = newval;
    },
    [s.SET_MEMDB_STATS](state, newval) {

        state.memDBStats = newval;
    },
    [s.SET_START_TIME](state, newval) {
        if (Object.keys(state.startTime).length !== 0 && Object.keys(newval).length !== 0) {
            state.interval = newval.diff(state.startTime, 'seconds');
        }
        state.startTime = newval;
    },
    [s.SET_INTERVAL](state, newval) {
        state.interval = newval;
    },
    [s.SET_PROGRESS](state, newval) {
        if (newval > state.maxDbSize)
            state.progress = state.maxDbSize;
        else
            state.progress = newval;
    },
    [s.SET_STORE_UPDATED](state, newval) {
        state.storeWillUpdate = newval;
    },
    [s.SET_MAX_DB_SIZE](state, newval) {
        state.maxDbSize = newval;
    },
    [s.SET_IS_OFFLINE](state, newval) {
        state.isOffline = newval;
    }
}

